import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../services/user.service';
import { LocalStorage } from '../../shared/wrappers/LocalStorage';
import { environment } from '../../../environments/environment';
import {UserAdProfile} from "../../models/user-ad-profile.model";
import {UserAdProfileService} from "../../services/user-ad-profile.service";


@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {
    loading:boolean =  false;

    constructor(private route:ActivatedRoute,
                private userService: UserService,
                private localStorage: LocalStorage,
                private userAdProfileService: UserAdProfileService,
    ) { }

    async ngOnInit() {
        this.displayLoading(true);
        const token = this.route.queryParams['value']['token']?this.route.queryParams['value']['token']:null;
        await this.validateToken(token);
        this.displayLoading(false);
    }

    async validateToken(token:string): Promise<void>{
        if(!token){
            this.navigateToLogin();
        } else {
            const userProfile: UserAdProfile = await this.userAdProfileService.getProfile(token);
            if (!userProfile || (userProfile && !userProfile.mail)) {
                this.navigateToLogin();
            }
            const user = await this.userService.getUserByUsername(userProfile.mail);
            if (!user) {
                this.navigateToLogin();
            }
            this.persistUserOnLocalStorage(user);
            this.navigateToHome();
        }
    }

    displayLoading(display:boolean){
        this.loading = display;
    }

    persistUserOnLocalStorage(user){
        this.localStorage.persist('user',user);
        this.localStorage.persist('login-reset-v6', 'true');
    }

    navigateToHome(){
        console.log('navigating to home');
        window.location.href = `${environment.frontBaseUrl}/home`;
    }

    navigateToLogin(){
        window.location.href = `${environment.frontBaseUrl}/login`;
    }

}



// WEBPACK FOOTER //
// ./src/app/views/auth/auth.component.ts